import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 200px;
`

export const Content = styled.div`
  position: relative;
  background-color: white;
  max-width: 1000px;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* padding-bottom: 82px; */
  /* border: 1px solid #64748b; */
  border-radius: 10px;
  box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  @media (max-width: 640px) {
    padding-bottom: 64px;
  }
  @media (max-width: 425px) {
    padding-bottom: 61px;
  }
`

export const BackContainer = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 100;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(122, 122, 122, 0.5);
  border-radius: 50%;
`

export const Cover = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const CoverImage = styled.img`
  width: 100%;
  max-height: 562.5px;
  object-fit: cover;
`

export const Detail = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 65% 35%;

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
  }
`

export const DetailContent1 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 20px 0px 40px;

  @media (max-width: 720px) {
    padding: 30px 30px 0 30px;
  }
  @media (max-width: 640px) {
    padding: 20px 30px 0 30px;
  }
  @media (max-width: 425px) {
    padding: 15px 20px 0 20px;
  }
`

export const DetailContent2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 40px 40px 20px;

  @media (max-width: 720px) {
    padding: 0 30px 0 30px;
  }
  @media (max-width: 425px) {
    padding: 0 20px 0 20px;
  }
`

export const DetailContent3 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 40px 60px 40px;

  @media (max-width: 720px) {
    padding: 0 30px 0 30px;
  }
  @media (max-width: 425px) {
    padding: 0 20px 0 20px;
  }
`

export const RatingAndShare = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 35px;
  gap: 20px;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-start;
  }
  @media (max-width: 720px) {
    flex-direction: row;
    justify-content: space-between;
  }
  @media (max-width: 425px) {
    margin-bottom: 15px;
  }
  @media (max-width: 300px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`

export const CourseNameContainer = styled.div`
  margin: 15px 40px 0px 40px;

  @media (max-width: 720px) {
    margin: 15px 30px 0 30px;
  }
  @media (max-width: 640px) {
    margin: 15px 30px 0 30px;
  }
  @media (max-width: 425px) {
    margin: 15px 20px 0 20px;
  }
`
